import { authApiCall } from '../auth/saga';

export const getAffiliateBusinesses = (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return authApiCall({ url: `/users/affiliate-businesses/${qs ? `?${qs}` : ''}`, method: 'get' });
};

export const createAffiliateBusiness = (data) =>
  authApiCall({ url: '/users/affiliate-businesses/create/', method: 'post', data });

export const updateAffiliateBusiness = (id, data) =>
  authApiCall({ url: `/users/affiliate-businesses/${id}/update/`, method: 'patch', data });

export const deleteAffiliateBusiness = (id) =>
  authApiCall({ url: `/users/affiliate-businesses/${id}/delete/`, method: 'delete' });

export const getAffiliateBusinessDetail = (id) =>
  authApiCall({ url: `/users/affiliate-businesses/${id}/`, method: 'get' });

export const getAffiliateBusiness = (id) =>
  authApiCall({ url: `/users/affiliate-businesses/${id}/`, method: 'get' });
